export default "__VITE_PUBLIC_ASSET__8370e861__"